var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNetflix({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1342 21.0388L55.1113 34.0659L55.0883 47.0931L54.0165 44.069C54.0162 44.0679 54.0148 44.0641 54.0145 44.063L52.6295 73.065C53.9912 76.9104 54.7208 78.9632 54.729 78.9714C54.7397 78.9822 55.5157 79.029 56.4534 79.0755C59.2946 79.2165 62.8153 79.5186 65.4862 79.8504C66.1046 79.9273 66.6368 79.9666 66.6688 79.9379C66.7009 79.9092 66.7183 66.6452 66.7076 50.4622L66.6881 21.0388H60.9112H55.1342V21.0388Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 0.0820533
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2365 21V50.4533C34.2365 66.6526 34.2523 79.9225 34.2717 79.9419C34.2911 79.9613 35.2944 79.8666 36.5011 79.7315C37.7078 79.5963 39.3756 79.4283 40.2073 79.3581C41.4828 79.2504 45.291 79.0055 45.7319 79.0028C45.8602 79.002 45.8685 78.3402 45.887 66.5276L45.9067 54.0533L46.8281 56.6603C46.9705 57.0633 47.0152 57.1891 47.1539 57.5816L48.5385 28.5868C48.2451 27.7574 48.3989 28.1928 48.0627 27.2422C46.9314 24.0436 45.9714 21.3305 45.9293 21.2132L45.8527 21H40.0447H34.2365V21Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 0.0820533
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2365 21V37.533L45.8832 68.4274C45.8844 67.7195 45.8858 67.3369 45.887 66.5276L45.9067 54.0533L46.8281 56.6603C51.9571 71.1736 54.7128 78.9552 54.729 78.9714C54.7397 78.9822 55.5157 79.029 56.4534 79.0755C59.2946 79.2165 62.8154 79.5186 65.4862 79.8505C66.1046 79.9273 66.6368 79.9666 66.6689 79.9379C66.6909 79.9182 66.7053 73.4145 66.7091 64.2396L55.1169 30.9121L55.1114 34.066L55.0883 47.0931L54.0165 44.069C52.9693 41.114 52.27 39.1379 48.0627 27.2422C46.9314 24.0436 45.9714 21.3305 45.9293 21.2132L45.8527 21H40.0447H34.2365H34.2365Z",
    fill: "url(#paint0_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2367 21L45.9067 54.0683V54.0533L46.8281 56.6603C51.9571 71.1736 54.7128 78.9552 54.729 78.9714C54.7397 78.9822 55.5157 79.029 56.4534 79.0755C59.2946 79.2165 62.8154 79.5186 65.4862 79.8505C66.1014 79.9269 66.6309 79.9662 66.6679 79.9383L55.0883 47.0871V47.0931L54.0165 44.069C52.9693 41.114 52.27 39.1379 48.0627 27.2422C46.9314 24.0436 45.9714 21.3305 45.9293 21.2132L45.8527 21H40.0447H34.2367V21Z",
    fill: "#E50914"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1342 21.0388L55.1113 34.0659L55.0883 47.0931L54.0165 44.069C54.0162 44.0679 54.0148 44.0641 54.0145 44.063L52.6295 73.065C53.9912 76.9104 54.7208 78.9632 54.729 78.9714C54.7397 78.9822 55.5157 79.029 56.4534 79.0755C59.2946 79.2165 62.8153 79.5186 65.4862 79.8504C66.1046 79.9273 66.6368 79.9666 66.6688 79.9379C66.7009 79.9092 66.7183 66.6452 66.7076 50.4622L66.6881 21.0388H60.9112H55.1342V21.0388Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 0.0820533
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2365 21V50.4533C34.2365 66.6526 34.2523 79.9225 34.2717 79.9419C34.2911 79.9613 35.2944 79.8666 36.5011 79.7315C37.7078 79.5963 39.3756 79.4283 40.2073 79.3581C41.4828 79.2504 45.291 79.0055 45.7319 79.0028C45.8602 79.002 45.8685 78.3402 45.887 66.5276L45.9067 54.0533L46.8281 56.6603C46.9705 57.0633 47.0152 57.1891 47.1539 57.5816L48.5385 28.5868C48.2451 27.7574 48.3989 28.1928 48.0627 27.2422C46.9314 24.0436 45.9714 21.3305 45.9293 21.2132L45.8527 21H40.0447H34.2365V21Z",
    fill: "#B1060F",
    stroke: "black",
    strokeWidth: 0.0820533
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2365 21V37.533L45.8832 68.4274C45.8844 67.7195 45.8858 67.3369 45.887 66.5276L45.9067 54.0533L46.8281 56.6603C51.9571 71.1736 54.7128 78.9552 54.729 78.9714C54.7397 78.9822 55.5157 79.029 56.4534 79.0755C59.2946 79.2165 62.8154 79.5186 65.4862 79.8505C66.1046 79.9273 66.6368 79.9666 66.6689 79.9379C66.6909 79.9182 66.7053 73.4145 66.7091 64.2396L55.1169 30.9121L55.1114 34.066L55.0883 47.0931L54.0165 44.069C52.9693 41.114 52.27 39.1379 48.0627 27.2422C46.9314 24.0436 45.9714 21.3305 45.9293 21.2132L45.8527 21H40.0447H34.2365H34.2365Z",
    fill: "url(#paint1_radial)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.2367 21L45.9067 54.0683V54.0533L46.8281 56.6603C51.9571 71.1736 54.7128 78.9552 54.729 78.9714C54.7397 78.9822 55.5157 79.029 56.4534 79.0755C59.2946 79.2165 62.8154 79.5186 65.4862 79.8505C66.1014 79.9269 66.6309 79.9662 66.6679 79.9383L55.0883 47.0871V47.0931L54.0165 44.069C52.9693 41.114 52.27 39.1379 48.0627 27.2422C46.9314 24.0436 45.9714 21.3305 45.9293 21.2132L45.8527 21H40.0447H34.2367V21Z",
    fill: "#E50914"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9336 50.131) rotate(-19.0982) scale(7.36008 269.594)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9336 50.131) rotate(-19.0982) scale(7.36008 269.594)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetflix);
export default __webpack_public_path__ + "static/media/Netflix.7ed0d87d3980754f1fc7a538372590e0.svg";
export { ForwardRef as ReactComponent };